module.exports = __webpack_public_path__ + "22d51a30f68ce5419d51b665337a8acb.svg";